var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurancePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25684 2.29738C7.73366 2.10665 8.26634 2.10665 8.74316 2.29738L12.1553 3.66164C12.6656 3.86588 13 4.361 13 4.91066V6.39015C13 9.25 11.4992 11.9002 9.04688 13.3716C8.4024 13.7582 7.5976 13.7582 6.95312 13.3716C4.50082 11.9002 3 9.25 3 6.39015V4.91066C3 4.361 3.33443 3.86588 3.84473 3.66164L7.25684 2.29738ZM7.7334 5.49953C7.51264 5.49953 7.33326 5.67922 7.33301 5.89992V6.83254H6.40039C6.17963 6.83254 6.00025 7.01223 6 7.23293V7.76613C6 7.98705 6.17948 8.16652 6.40039 8.16652H7.33301V9.09914C7.33301 9.32005 7.51248 9.49953 7.7334 9.49953H8.2666C8.48752 9.49953 8.66699 9.32005 8.66699 9.09914V8.16652H9.59961C9.82052 8.16652 10 7.98705 10 7.76613V7.23293C9.99975 7.01223 9.82037 6.83254 9.59961 6.83254H8.66699V5.89992C8.66674 5.67922 8.48736 5.49953 8.2666 5.49953H7.7334Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePlus);
export default __webpack_public_path__ + "static/media/Insurance_plus.4203ba723c1fd43753e0059d3bba59bc.svg";
export { ForwardRef as ReactComponent };